define([
	'internal_util/Util',
	'internal_util/LocalizationUtil',
	'internal_util/Configuration'
], function (
	Util,
	LocalizationUtil,
	Configuration
) {
	'use strict';

	function getClientInfo() {
		return {
			userAgent : navigator.userAgent,
			platform : navigator.platform,
			locale : LocalizationUtil.getLocale()
		};
	}

	function redirectTo(url) {
		window.location.replace(url);
	}
	
	function topRedirectTo(url) {
		window.top.location.replace(url);
	}

	function isSupportedBrowser() {
		var userAgent = navigator.userAgent.toLowerCase();

		// IE < 10
		if (window.XDomainRequest) {
			if (Function('/*@cc_on return /^10/.test(@_jscript_version) @*/')()) {
				return true;
			}

			return false;
		}

		// Old native Android browser
		if (userAgent.indexOf('mozilla/5.0') > -1
				&& userAgent.indexOf('android ') > -1
				&& userAgent.indexOf('applewebkit') > -1
				&& !(userAgent.indexOf('chrome') > -1)) {
			return false;
		}

		return true;
	}

	function isMobileClient() {
		var agent = navigator.userAgent.toLowerCase(),
			version = navigator.hasOwnProperty('appVersion') ? navigator.appVersion.toLowerCase() : '';

		if (/mobile|mini|fennec|android|ip(ad|od|hone)/.test(agent)
				|| /mobile|mini|fennec|android|ip(ad|od|hone)/.test(version)) {
			return true;
		}

		return false;
	}

	function isWebApp() {
		var parameters = Util.parseParameters();

		if (parameters.hasOwnProperty('mode') && parameters['mode'] === 'webapp') {
			return true;
		}

		return false;
	}

	function supportsUserMedia() {
		return navigator.getUserMedia
				|| navigator.webkitGetUserMedia
				|| navigator.mozGetUserMedia;
	}


	return {
		getClientInfo : getClientInfo,
		redirectTo : redirectTo,
		topRedirectTo : topRedirectTo,
		isSupportedBrowser : isSupportedBrowser,
		isMobileClient : isMobileClient,
		isWebApp : isWebApp,
		supportsUserMedia : supportsUserMedia
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/util/ClientUtil.js
// module id = 20
// module chunks = 6